module.exports = __webpack_public_path__ + "img/play-icon.f9af9175.svg";